<!-- <div class="px-6 w-full lg:max-w-8xl mx-auto space-y-12"> -->
<div class="p-6 md:p-12 lg:py-20 lg:pb-0 container mx-auto ">
    <div class="grid grid-cols-12 items-end lg:items-start gap-4 mb-6 lg:mb-12" data-aos="fade-up"  data-aos-delay="400">
        <div class="col-span-12 md:col-span-12">
            <div class="">
                <h2 class="text-white text-lg md:text-xl xl:text-4xl mi--font-regular lg:!leading-[1.16]">BX Infinity Chain,</h2>
                <p class="text__yg--gradient text-xs md:text-base xl:text-lg mi--font-regular mt-2">An EVM-based Layer 1 Blockchain with a Multichain architecture</p>
            </div>
        </div>
        <!-- <div class="col-span-12 md:col-span-4">
            <div class="flex items-center justify-end gap-4 mt-6 lg:mt-12">
                <a class="cursor-pointer text-xs md:text-sm xl:text-lg sy--font-medium text-white border-solid border-[#D9D9D9] border-b py-1 lg:py-3 animate-slide">Read More <img class="inline ml-2" src="assets/landing-new/icons/arrow-right.svg" alt=""></a>
            </div>
        </div> -->
    </div>

    <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
            <owl-carousel-o [options]="customOptions">
                <ng-template carouselSlide class="text-white">
                    <div data-aos="fade-up"  data-aos-delay="500" class="p-6 lg:px-12 bx__infinity-chain animate-slide lg:border-x border-solid lg:border-[#d9d9d91a]">
                        <div class="flex justify-between items-start gap-4">
                            <img src="assets/landing-new/icons/infinity-chain/scalability.svg" class="!w-auto animate--float !animate-none pb-4" alt="">
                            <img src="assets/landing-new/icons/arrow-right-violet.svg" class="!w-auto"  alt="">
                        </div>
                        <div class="space-y-4">
                            <h2 class="text__yg--gradient text-sm md:text-base xl:text-lg mi--font-regular">Built for scalability</h2>
                            <p class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide text-justify">Create highly scalable DApps, Tokens, NFTs, and Metaverse with BX Infinity Chain. Handcrafted for businesses that want to scale.
                            </p>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide class="text-white">
                    <div data-aos="fade-up"  data-aos-delay="600" class="p-6 lg:px-12 bx__infinity-chain animate-slide lg:border-x border-solid lg:border-[#d9d9d91a]">
                        <div class="flex justify-between items-start gap-4">
                            <img src="assets/landing-new/icons/infinity-chain/speed.svg" class="!w-auto animate--float !animate-none pb-4" alt="">
                            <img src="assets/landing-new/icons/arrow-right-violet.svg"  class="!w-auto"  alt="">
                        </div>
                        <div class="space-y-4">
                            <h2 class="text__yg--gradient text-sm md:text-base xl:text-lg mi--font-regular">Built for speed</h2>
                            <p class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide text-justify">BX Infinity Chain as the name suggests has finite possibilities. Access high-speed transactions with a proprietary blend of BFT and Proof-of-Stake.
                            </p>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide class="text-white">
                    <div data-aos="fade-up"  data-aos-delay="700" class="p-6 lg:px-12 bx__infinity-chain animate-slide lg:border-x border-solid lg:border-[#d9d9d91a]">
                        <div class="flex justify-between items-start gap-4">
                            <img src="assets/landing-new/icons/infinity-chain/affordable.svg" class="!w-auto animate--float !animate-none pb-4" alt="">
                            <img src="assets/landing-new/icons/arrow-right-violet.svg" class="!w-auto" alt="">
                        </div>
                        <div class="space-y-4">
                            <h2 class="text__yg--gradient text-sm md:text-base xl:text-lg mi--font-regular">Built to be affordable</h2>
                            <p class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide text-justify">We do not believe that blockchain should be the plaything of a few people. Built your project on the Infinity Chain with low gas fees.
                            </p>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide class="text-white">
                    <div data-aos="fade-up"  data-aos-delay="800" class="p-6 lg:px-12 bx__infinity-chain animate-slide lg:border-x border-solid lg:border-[#d9d9d91a]">
                        <div class="flex justify-between items-start gap-4">
                            <img src="assets/landing-new/icons/infinity-chain/multichain-architecht.svg" class="!w-auto !animate-none pb-4" alt="">
                            <img src="assets/landing-new/icons/arrow-right-violet.svg" class="!w-auto" alt="">
                        </div>
                        <div class="space-y-4">
                            <h2 class="text__yg--gradient text-sm md:text-base xl:text-lg mi--font-regular">Multichain Architecture</h2>
                            <p class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide text-justify">The BX Infinity Chain will keep on growing as dApps demand more scalability. Run applications on multiple side chains for increased performance and privacy.
                            </p>
                        </div>
                    </div>
                </ng-template>
              </owl-carousel-o>
        </div>
        <!-- <div class="col-span-12 md:col-span-4 py-6 md:p-6 lg:px-12 animate-slide">
            <div class="flex justify-between items-start gap-4">
                <img src="assets/landing-new/icons/infinity-chain/scalability.svg" class="!animate-none pb-4" alt="">
                <img src="assets/landing-new/icons/arrow-right-violet.svg"  alt="">
            </div>
            <div class="space-y-4">
                <h2 class="text__yg--gradient text-sm md:text-base xl:text-lg mi--font-regular">Built for scalability</h2>
                <p class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide">Create highly scalable decentralized applications, tokens, and NFTs with a blockchain.</p>
            </div>
        </div> -->
        <!-- <div class="col-span-12 md:col-span-4 py-6 md:p-6 lg:px-12 animate-slide">
            <div class="flex justify-between items-start gap-4">
                <img src="assets/landing-new/icons/infinity-chain/speed.svg" class="!animate-none pb-4" alt="">
                <img src="assets/landing-new/icons/arrow-right-violet.svg" alt="">
            </div>
            <div class="space-y-4">
                <h2 class="text__yg--gradient text-sm md:text-base xl:text-lg mi--font-regular">Built for speed</h2>
                <p class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide">BX Infinity Chain as the name suggests has finite possib-ilities. Access high speed transactions with.</p>
            </div>
        </div> -->
        <!-- <div class="col-span-12 md:col-span-4 py-6 md:p-6 lg:px-12 animate-slide">
            <div class="flex justify-between items-start gap-4">
                <img src="assets/landing-new/icons/infinity-chain/affordable.svg" class="!animate-none pb-4" alt="">
                <img src="assets/landing-new/icons/arrow-right-violet.svg" alt="">
            </div>
            <div class="space-y-4">
                <h2 class="text__yg--gradient text-sm md:text-base xl:text-lg mi--font-regular">Built to be affordable</h2>
                <p class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide">We do not believe that blockchain should be the plaything of a few people. We believe blockchain.</p>
            </div>
        </div> -->
    </div>
</div>
